import * as React from "react";

/**
 * The method used to Sign In or Sign Up
 */
type AuthMethod = "Wallet" | "Email" | "Magic Link";

/**
 * Tracked button clicks
 */
type ButtonEvent =
  | "Art Medium"
  | "Artist Collection"
  | "Buy Additional Submissions"
  | "Connect Wallet"
  | "Download"
  | "Home Hero CTA"
  | "Open Call Submit Edit"
  | "Open Call Submit"
  | "Open Call Vote"
  | "Post Link"
  | "Search Open"
  | "Search Results"
  | "Sign In"
  | "Sign Up"
  | "Skip Application"
  | "Social Link"
  | "Claim Free Domain"
  | "Get Premium Domain"
  | "Upgrade to PRO";

/**
 * Tracked form submissions
 */
type FormEvent =
  | "Email Sign In"
  | "Email Sign Up"
  | "Artist Application"
  | "Open Call Submission"
  | "Open Call Submission Edit"
  | "Open Call Partner Curation"
  | "Open Call Vote";

type TrackedEvent =
  | {
      name: "Sign In" | "Sign Up";
      Method: AuthMethod;
    }
  | {
      name: "Button Click";
      ButtonName: ButtonEvent;
      ButtonContext: string;
      Resource?: string;
      ButtonDestination?: string;
    }
  | {
      name: "Form Submit";
      FormName: FormEvent;
      FormContext?: string;
      ArtistId?: string;
      ApplicationId?: string;
      OpenCallId?: string;
    }
  | {
      name: "Menu Click";
      MenuName: string;
    }
  | {
      name: "Share";
      ShareType: "Tweet" | "Copy";
    };

/**
 * Track a user event with analytics
 */
const trackEvent = (_event: TrackedEvent) => null;

/**
 * Set User for analytics tracking session
 */
const setUser = (_user: {
  roles: string[];
  id: string;
  name?: string;
  email?: string;
  claimedArtistPageIds?: string[];
}) => null;

/**
 * Remove user from analytics tracking session
 */
const removeUser = () => null;

/**
 * Log page view in analytics
 */
const usePageTracking = () => {
  React.useEffect(() => undefined, []);
};

const trackShareTweet = () =>
  trackEvent({
    name: "Share",
    ShareType: "Tweet",
  });
const trackShareCopy = () =>
  trackEvent({
    name: "Share",
    ShareType: "Copy",
  });

export {
  setUser,
  removeUser,
  trackEvent,
  usePageTracking,
  trackShareTweet,
  trackShareCopy,
};
